import { Usuario } from "./usuario.model";
import { TipoSujetoObligado } from "./tipo-sujeto-obligado.model";
import { Cliente } from "./cliente.model";
import { Direccion } from "./direccion.model";
import { SectorActividad } from "./sector-actividad.model";
import { RazonSocial } from "./razon-social.model";
import { CorreoElectronico } from "./correo-electronico.model";
import { Telefono } from "./telefono.model";

export class SujetoObligado {
    id: number;
    tipo: string;
    nombre: string;
    apellido: string;
    nombreFiscal: string;
    razonSocial: RazonSocial;
    direccionFisica: Direccion;
    direccionFiscal: Direccion;
    correoElectronico: string;
    //sectorIndustrial: SectorActividad;
    tipoSujetoObligado: TipoSujetoObligado;
    externalId: string;
    descripcion: string;
    telefono: string;
    active: number;
    clientes: Cliente[];
    representantes: Usuario[];
    nombreCompleto: string;

    /**
     * Constructor
     *
     * @param SujetoObligado
     */
    constructor(sujetoObligado) {
        {
            this.id = sujetoObligado.id || null;
            this.nombre = sujetoObligado.nombre || "";
            this.apellido = sujetoObligado.apellido || "";
            this.nombreFiscal = sujetoObligado.nombreFiscal || "";
            this.nombreCompleto = sujetoObligado.nombreCompleto || "";
            this.razonSocial =
                sujetoObligado.razonSocial || new RazonSocial({});
            this.direccionFisica =
                sujetoObligado.direccionFisica || new Direccion({});
            this.direccionFiscal =
                sujetoObligado.direccionFiscal || new Direccion({});
            this.correoElectronico =
                sujetoObligado.correoElectronico || new CorreoElectronico({});
            this.active = sujetoObligado.active || 0;
            this.tipo = sujetoObligado.tipo || "PERSONA_FISICA";
            this.telefono = sujetoObligado.telefono || new Telefono({});
            this.clientes = sujetoObligado.clientes || [];
            this.representantes = sujetoObligado.representantes || [];
            this.externalId = sujetoObligado.externalId || "";
            /*this.sectorIndustrial =
                sujetoObligado.sectorIndustrial || new SectorActividad({});*/
            this.descripcion = sujetoObligado.descripcion || "";
            this.tipoSujetoObligado =
                sujetoObligado.tipoSujetoObligado || new TipoSujetoObligado({});
        }
    }
}
